import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Sidebar from '../components/dashboard/Sidebar';
import DashboardHeader from '../components/dashboard/DashboardHeader';

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { darkMode } = useSelector((state) => state.ui) || { darkMode: false };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Add dashboard-body class to body element when component mounts
  // and toggle dark-mode class based on darkMode state
  useEffect(() => {
    document.body.classList.add('dashboard-body');
    
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    
    // Cleanup function to remove the classes when component unmounts
    return () => {
      document.body.classList.remove('dashboard-body');
      document.body.classList.remove('dark-mode');
    };
  }, [darkMode]);

  return (
    <div className={`flex h-screen ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} darkMode={darkMode} />

      {/* Main Content */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <DashboardHeader toggleSidebar={toggleSidebar} darkMode={darkMode} />
        
        <main className={`flex-1 overflow-y-auto p-4 md:p-6 ${darkMode ? 'bg-gray-900' : 'bg-gray-50'} w-full relative`}>
          <div className="w-full max-w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;